// @TODO: Deprecate this constant
const API_ROOT = '';
const LOGIN_MICROSOFT = `${API_ROOT}/api/login/microsoft`;
const LOGIN_GOOGLE = `${API_ROOT}/api/login/google`;
const LOGIN_OKTA = `${API_ROOT}/api/login/okta`;

const TABLES = {
  LEASE_AUDITS: 'lease_audits',
  LEASE_AUDIT_HOT_SPOTS: 'lease_audit_hot_spots',
  LEASE_AUDIT_HOT_SPOT_CHECKS: 'lease_audit_hot_spot_checks',
};

export { API_ROOT, LOGIN_GOOGLE, LOGIN_MICROSOFT, LOGIN_OKTA, TABLES };
